import { supabase } from './supabaseClient';
import { logError } from './logger';

export const AVATARS_BUCKET = 'avatars';
export const TASK_EVIDENCE_BUCKET = 'task-evidence';
export const JOURNAL_IMAGES_BUCKET = 'journal-images';
export const CHAT_IMAGES_BUCKET = 'chat-images';

const buildFilePath = (userId: string, folder: string, file: File) => {
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '-').toLowerCase();
  return `${userId}/${folder}/${Date.now()}-${safeName}`;
};

export const uploadPublicAvatar = async (userId: string, file: File): Promise<{ path: string; publicUrl: string } | null> => {
  const path = buildFilePath(userId, 'avatar', file);
  const { error } = await supabase.storage.from(AVATARS_BUCKET).upload(path, file, {
    cacheControl: '3600',
    upsert: true
  });

  if (error) {
    logError('storage', 'Falha ao enviar avatar para o storage.', error);
    return null;
  }

  const { data } = supabase.storage.from(AVATARS_BUCKET).getPublicUrl(path);
  return {
    path,
    publicUrl: data.publicUrl
  };
};

export const uploadPrivateImage = async (
  bucket: string,
  userId: string,
  folder: string,
  file: File
): Promise<{ path: string } | null> => {
  const path = buildFilePath(userId, folder, file);
  const { error } = await supabase.storage.from(bucket).upload(path, file, {
    cacheControl: '3600',
    upsert: false
  });

  if (error) {
    logError('storage', `Falha ao enviar imagem privada para ${bucket}.`, error);
    return null;
  }

  return { path };
};

export const getSignedPrivateImageUrl = async (bucket: string, path?: string | null): Promise<string | null> => {
  if (!path) {
    return null;
  }

  const { data, error } = await supabase.storage.from(bucket).createSignedUrl(path, 60 * 60);
  if (error) {
    logError('storage', `Falha ao gerar URL assinada para ${bucket}.`, error);
    return null;
  }

  return data.signedUrl;
};
